import GroceryCategoriesTable from 'components/GroceryCategories';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const GroceryCategories = () => {
  const permissions = useSelector(
    (state: any) => state?.userProfile?.data?.permissions,
  );
  const canView = checkPermission(permissions, {
    permissionName: 'GroceryCategories',
    permission: ['viewAll'],
  });
  return <div>{canView && <GroceryCategoriesTable />}</div>;
};
